// import store from "../state/Cliend"
import { T_BASE_URL } from '../utils'
import { oauthAuthHeader } from '../utils';


export async function cliendList(ccquary, ccoption, namequary, nameoption, startDate, endDate, getData) {
    const U_BASE = T_BASE_URL + "documentClientList/" + getData
    localStorage.setItem("StartDate", startDate);
    localStorage.setItem("EndDate", endDate);
    var raw = JSON.stringify({ "cc": ccquary, "ccSort": ccoption, "name": namequary, "nameSort": nameoption, "startDate": startDate, "endDate": endDate, "search": [] });
    var requestOptions = {
        method: 'POST',
        headers: {
            ...oauthAuthHeader()
        },
        body: raw,
        redirect: 'follow'
    };

    const res = await fetch(U_BASE, requestOptions)
    return res;

}

export async function cliendDetail(id, startDate, endDate) {
    const U_BASE = T_BASE_URL + "/documentClientDetail/"
    var raw = JSON.stringify({ "startDate": startDate, "endDate": endDate });
    var requestOptions = {
        method: 'POST',
        headers: {
            ...oauthAuthHeader()
        },
        body: raw,
        redirect: 'follow'
    };
    const res = await fetch(U_BASE + id, requestOptions)
    return res;
}